import React from "react";

export default function TermsPage() {
  return (
    <div className="p-20 max-w-4xl mx-auto space-y-10">

      <section className="bg-white shadow-md rounded-2xl p-8 space-y-6 mt-20">
      
        <h1 className="text-3xl font-bold text-center">Terms and Conditions</h1>
        <h2 className="text-xl font-semibold text-center">Mowgi Communications Terms and Conditions</h2>

        <section className="mt-6">
          <h3 className="text-lg font-semibold">1. Acceptance of Terms</h3>
          <p className="mt-1 text-gray-700">
            By accessing or using any part of the Mowgi Communications website (the 
            “Site”), you agree to be bound by these Terms and Conditions. If you do not 
            agree to these Terms and Conditions, please do not access or use the Site.
          </p>
        </section>

        <section className="mt-6">
          <h3 className="text-lg font-semibold">2. Modifications to Terms</h3>
          <p className="mt-1 text-gray-700">
            Mowgi Communications reserves the right to modify these Terms and Conditions 
            at any time. Any changes will be effective immediately upon posting on the Site. 
            Your continued use of the Site after such modifications constitutes your 
            acceptance of the revised Terms and Conditions.
          </p>
        </section>

        <section className="mt-6">
          <h3 className="text-lg font-semibold">3. Intellectual Property</h3>
          <p className="mt-1 text-gray-700">
            All content on the Site, including but not limited to text, graphics, logos, 
            images, and software, is the property of Mowgi Communications or its licensors 
            and is protected by copyright and other intellectual property laws. You may not 
            reproduce, distribute, modify, or create derivative works from this content 
            without the prior written consent of Mowgi Communications.
          </p>
        </section>

        <section className="mt-6">
          <h3 className="text-lg font-semibold">4. User Conduct</h3>
          <p className="mt-1 text-gray-700">
            You agree to use the Site only for lawful purposes and in a manner that does not 
            infringe the rights of others. You are prohibited from engaging in any activity 
            that could damage, disable, overburden, or impair the Site or interfere with the 
            use and enjoyment of the Site by any other user.
          </p>
        </section>

        <section className="mt-6">
          <h3 className="text-lg font-semibold">5. Limitation of Liability</h3>
          <p className="mt-1 text-gray-700">
            Mowgi Communications shall not be liable for any direct, indirect, incidental, 
            consequential, or punitive damages arising out of or in connection with your use 
            of the Site or any content on the Site.
          </p>
        </section>

        <section className="mt-6">
          <h3 className="text-lg font-semibold">6. Governing Law</h3>
          <p className="mt-1 text-gray-700">
            These Terms and Conditions shall be governed by and construed in accordance with 
            the laws of Singapore.
          </p>
        </section>

        <section className="mt-6">
          <h3 className="text-lg font-semibold">7. Contact Us</h3>
          <p className="mt-1 text-gray-700">
            If you have any questions or concerns regarding these Terms and Conditions, please 
            contact us at <a href="mailto:teams@mowgicommunications.com" className="text-blue-600 underline">teams@mowgicommunications.com</a>.
          </p>
        </section>

        <p className="mt-10 text-gray-500 text-sm text-center">
          Copyright © 2025 Mowgi Communications. All rights reserved.
        </p>
      </section>
    </div>
  );
}
